import { Theme } from "../component/navigation/ThemeDropdown";

export default function DataIcon({
    isSelected,
    theme,
}: {
    isSelected: boolean;
    theme: Theme;
}) {
    return (
        <div style={{ display: "inline-block", cursor: "pointer" }}>
            <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37259 0 0 5.37258 0 12C0 18.6274 5.37259 24 12 24Z"
                    fill={
                        theme === "light"
                            ? isSelected
                                ? "#C6D92D"
                                : "#D8D8D8"
                            : isSelected
                              ? "#C6D92D"
                              : "#7A8690"
                    }
                    style={{
                        transition: "fill 0.3s ease",
                    }}
                />
                <path
                    d="M7.53892 7.92365H18.4244C18.8305 7.92365 19.1603 8.25342 19.1603 8.65952V17.1939C19.1603 17.6 18.8305 17.9298 18.4244 17.9298H7.53892C7.13281 17.9298 6.80304 17.6 6.80304 17.1939V8.65952C6.80304 8.25342 7.13281 7.92365 7.53892 7.92365Z"
                    fill={
                        theme === "light"
                            ? isSelected
                                ? "#FFFFFF"
                                : "#606161"
                            : isSelected
                              ? "#2D3748"
                              : "#2D3748"
                    }
                    style={{
                        transition: "fill 0.3s ease",
                    }}
                />
                <path
                    d="M18.4244 8.21675C18.6687 8.21675 18.8671 8.41523 18.8671 8.6595V17.1939C18.8671 17.4381 18.6687 17.6366 18.4244 17.6366H7.5389C7.29462 17.6366 7.09615 17.4381 7.09615 17.1939V8.6595C7.09615 8.41523 7.29462 8.21675 7.5389 8.21675H18.4244ZM18.4244 7.63049H7.5389C6.97096 7.63049 6.50989 8.09156 6.50989 8.6595V17.1939C6.50989 17.7618 6.97096 18.2229 7.5389 18.2229H18.4244C18.9923 18.2229 19.4534 17.7618 19.4534 17.1939V8.6595C19.4534 8.09156 18.9923 7.63049 18.4244 7.63049Z"
                    fill={
                        theme === "light"
                            ? isSelected
                                ? "#C6D92D"
                                : "#D8D8D8"
                            : isSelected
                              ? "#C6D92D"
                              : "#7A8690"
                    }
                    style={{
                        transition: "fill 0.3s ease",
                    }}
                />
                <path
                    d="M17.3405 7.24274H6.45496C6.21043 7.24274 6.01221 7.44096 6.01221 7.68548V16.2198C6.01221 16.4644 6.21043 16.6626 6.45496 16.6626H17.3405C17.585 16.6626 17.7832 16.4644 17.7832 16.2198V7.68548C17.7832 7.44096 17.585 7.24274 17.3405 7.24274Z"
                    fill={
                        theme === "light"
                            ? isSelected
                                ? "#C6D92D"
                                : "#D8D8D8"
                            : isSelected
                              ? "#C6D92D"
                              : "#7A8690"
                    }
                    style={{
                        transition: "fill 0.3s ease",
                    }}
                />
                <path
                    d="M16.4611 6.36334H5.57556C5.33104 6.36334 5.13281 6.56157 5.13281 6.80609V15.3404C5.13281 15.585 5.33104 15.7832 5.57556 15.7832H16.4611C16.7056 15.7832 16.9038 15.585 16.9038 15.3404V6.80609C16.9038 6.56157 16.7056 6.36334 16.4611 6.36334Z"
                    fill={
                        theme === "light"
                            ? isSelected
                                ? "#FFFFFF"
                                : "#606161"
                            : isSelected
                              ? "#2D3748"
                              : "#2D3748"
                    }
                    style={{
                        transition: "fill 0.3s ease",
                    }}
                />
                <path
                    d="M15.1878 8.87024H6.98623C6.77544 8.87024 6.60455 9.04112 6.60455 9.25192V9.32215C6.60455 9.53294 6.77544 9.70383 6.98623 9.70383H15.1878C15.3986 9.70383 15.5694 9.53294 15.5694 9.32215V9.25192C15.5694 9.04112 15.3986 8.87024 15.1878 8.87024Z"
                    fill={
                        theme === "light"
                            ? isSelected
                                ? "#C6D92D"
                                : "#D8D8D8"
                            : isSelected
                              ? "#C6D92D"
                              : "#7A8690"
                    }
                    style={{
                        transition: "fill 0.3s ease",
                    }}
                />
                <path
                    d="M15.1878 10.7511H6.98623C6.77544 10.7511 6.60455 10.922 6.60455 11.1328V11.203C6.60455 11.4138 6.77544 11.5847 6.98623 11.5847H15.1878C15.3986 11.5847 15.5694 11.4138 15.5694 11.203V11.1328C15.5694 10.922 15.3986 10.7511 15.1878 10.7511Z"
                    fill={
                        theme === "light"
                            ? isSelected
                                ? "#C6D92D"
                                : "#D8D8D8"
                            : isSelected
                              ? "#C6D92D"
                              : "#7A8690"
                    }
                    style={{
                        transition: "fill 0.3s ease",
                    }}
                />
                <path
                    d="M11.8656 12.4427H6.98623C6.77544 12.4427 6.60455 12.6136 6.60455 12.8244V12.8947C6.60455 13.1055 6.77544 13.2763 6.98623 13.2763H11.8656C12.0764 13.2763 12.2473 13.1055 12.2473 12.8947V12.8244C12.2473 12.6136 12.0764 12.4427 11.8656 12.4427Z"
                    fill={
                        theme === "light"
                            ? isSelected
                                ? "#C6D92D"
                                : "#D8D8D8"
                            : isSelected
                              ? "#C6D92D"
                              : "#7A8690"
                    }
                    style={{
                        transition: "fill 0.3s ease",
                    }}
                />
            </svg>
        </div>
    );
}
